import { BigNumber } from '@frontend/numeric';

interface ICalculateProfitOrLossParams {
  profit: number;
  lotSize: number;
  openPrice: number;
  currentPrice: number;
  contractSize: number;
  exchangeRate: number;
  isSellOrder?: boolean;
}

export const calculateProfitOrLoss = (params: ICalculateProfitOrLossParams) => {
  const { profit, currentPrice, openPrice, contractSize, lotSize, exchangeRate, isSellOrder = false } = params;

  if (currentPrice > 0) {
    const priceDiff = isSellOrder
      ? BigNumber(openPrice).minus(currentPrice) // For SELL: profit when price goes down
      : BigNumber(currentPrice).minus(openPrice); // For BUY: profit when price goes up

    return priceDiff.times(contractSize).times(lotSize).times(exchangeRate);
  }

  return BigNumber(profit);
};
